import React from 'react';
import './Banner.css'
const Banner = () => {
    return (
      <div className="max-width">
        <div className="css-19g42lq ">
          <div
            data-bn-type="text"
            className="governance-landing-header-subtitle css-1b13r3e"
          >
            Participate in SatoPAD Governance
          </div>
          <div className="governance-landing-header-main-title">
            SatoPAD DAO
          </div>
          <div data-bn-type="text" className="css-skkjos">
            Help in molding the future of SatoPAD, stake SAPI tokens to acquire the ability to vote and obtain incentives.
          </div>
          <div class="alert syncera-warning mt-4" role="alert">
            <i class="fas fa-exclamation-triangle"></i> Coming soon in operation.
          </div>
        </div>
      </div>
    );
}

export default Banner;
